export const BoxOpen1 = ({
  height = "16",
  width = "16",
}: {
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_92_5442)">
      <path
        d="M16.3839 4.28641L15.1105 2.17241L8.66653 0.0244141L2.22253 2.17241L0.961199 4.26508C0.644532 4.79308 0.585866 5.42641 0.799199 6.00308C1.00587 6.56241 1.44187 6.99508 1.9992 7.19841L1.99387 13.7611L8.66053 15.9831L15.3272 13.7611L15.3325 7.19841C15.8965 7.00108 16.3372 6.56775 16.5452 6.00641C16.7565 5.43508 16.6979 4.80841 16.3839 4.28508V4.28641ZM12.5592 2.72775L8.67187 4.02508L4.7832 2.72441L8.66653 1.42975L12.5592 2.72775ZM2.10387 4.95241L2.9652 3.52241L7.66387 5.09375L6.64453 6.79308C6.4852 7.05841 6.15453 7.18041 5.86253 7.08241L2.4752 5.95375C2.2772 5.88775 2.12187 5.73775 2.0492 5.54175C1.9772 5.34641 1.99653 5.13041 2.10387 4.95241ZM3.33253 7.64441L5.4412 8.34708C6.33653 8.64575 7.30253 8.28841 7.78853 7.47908L7.9992 7.12841L7.99587 14.3571L3.3292 12.8017L3.3332 7.64508L3.33253 7.64441ZM9.32853 14.3564L9.33187 7.12375L9.54453 7.47841C9.9152 8.09708 10.5659 8.45108 11.2519 8.45108C11.4645 8.45108 11.6805 8.41708 11.8919 8.34641L13.9992 7.64441L13.9952 12.8004L9.32853 14.3564ZM15.2952 5.54575C15.2252 5.73575 15.0745 5.88108 14.8825 5.94508L11.4705 7.08241C11.1785 7.18041 10.8479 7.05908 10.6885 6.79308L9.6712 5.09775L14.3719 3.52908L15.2419 4.97375C15.3459 5.14708 15.3659 5.35575 15.2952 5.54575Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_92_5442">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.666504)"
        />
      </clipPath>
    </defs>
  </svg>
);
